import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { RootState } from '../../models/RootState';
import {
  fetchBalance,
  logout,
  fetchBettingCurrency,
  setEventType,
} from '../../store';
import Modal from '../../components/Modal/Modal';

import {
  EXCHANGE_EVENT_TYPES,
  SPORTS_MAP,
  EXCH_SPORTS_MAP,
} from '../../constants/ExchangeEventTypes';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import './SubHeader.scss';
import { Backdrop, Button, Tabs } from '@material-ui/core';
import LoginForm from '../../components/LoginForm/LoginForm';
import { BRAND_DOMAIN, BRAND_NAME } from '../../constants/Branding';
import gift from '../../assets/images/common/gift.svg';
import { IonIcon, IonSpinner } from '@ionic/react';
import { WORLD_CUP, BBL_MEN, IPL_CUP } from '../../constants/IPLEvent';
import { DomainConfig } from '../../models/DomainConfig';
import { useDomainConfigHook } from '../../hooks/domainConfigHook';
import { checkForDomainConfig } from '../../util/domainConfigUtils';

type StoreProps = {
  allowedConfig: number;
  loggedIn: boolean;
  logout: Function;
  contentConfig: any;
  domainConfig: DomainConfig;
};

const SubHeader: React.FC<StoreProps> = (props) => {
  const { allowedConfig, domainConfig, contentConfig } = props;
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [subHeaders, setSubHeaders] = useState<any>([
    {
      name: 'Exchange',
      key: false,
      exact: false,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/exchange_sports/inplay',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 0,
      onClick: false,
    },
    {
      name: 'Change Site',
      key: false,
      exact: false,
      className: 'nav-link mob-view',
      activeClassName: null,
      buttonClassName: 'newlacunch-menu',
      icon: null,
      superScript: null,
      redirectionUrl: '/mo/theme',
      config: null,
      disable: false,
      priority: 1,
      onClick: false,
    },
    {
      name: 'Promotions',
      key: false,
      exact: false,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: (
        <IonIcon className="title-image gift_icon" color="primary" src={gift} />
      ),
      superScript: null,
      redirectionUrl: '/promotion',
      config: null,
      disable: false,
      priority: 2,
      onClick: false,
    },
    {
      name: 'Multi Markets',
      key: false,
      exact: false,
      className: 'nav-link',
      activeClassName: null,
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/exchange_sports/multi-markets',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 3,
      onClick: false,
    },
    {
      name: 'Sportsbook',
      key: false,
      exact: false,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/premium_sports',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 4,
      onClick: false,
    },
    // {
    //   name: 'Virtual Sports',
    //   key: false,
    //   exact: false,
    //   className: 'nav-link',
    //   activeClassName: 'active-link',
    //   buttonClassName: 'nav-link-btn',
    //   icon: null,
    //   superScript: null,
    //   redirectionUrl: '/virtual_sports',
    //   config: CONFIG_PERMISSIONS.casino,
    //   disable: false,
    //   priority: 5,
    //   onClick: false,
    // },
    {
      name: 'Indian Casino',
      key: false,
      exact: false,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/indian_casino',
      config: CONFIG_PERMISSIONS.indian_casino,
      disable: false,
      priority: 6,
      onClick: false,
    },
    {
      name: 'Live Casino',
      key: false,
      exact: false,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/casino',
      config: CONFIG_PERMISSIONS.live_casino,
      disable: false,
      priority: 7,
      onClick: false,
    },
    {
      name: 'Fun Games',
      key: false,
      exact: false,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn fun-games-link',
      icon: null,
      superScript: <span className="badge">New</span>,
      redirectionUrl: '/fun_games',
      config: CONFIG_PERMISSIONS.live_casino,
      disable: false,
      priority: 8,
      onClick: false,
    },
    // {
    //   name: "Men's WORLD Cup",
    //   key: false,
    //   exact: false,
    //   className: 'nav-link cup-color-change',
    //   activeClassName: 'active-link',
    //   buttonClassName: 'nav-link-btn ',
    //   icon: null,
    //   superScript: null,
    //   redirectionUrl: `/exchange_sports/cricket/icc-world-cup-t20-2024/icc-world-cup-t20-2024/${btoa(
    //     WORLD_CUP.routeHash
    //   )}`,
    //   config: CONFIG_PERMISSIONS.cricket,
    //   disable: false,
    //   priority: 9,
    //   onClick: false,
    // },

    {
      name: 'Cricket',
      key: true,
      exact: true,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/exchange_sports/cricket',
      config: CONFIG_PERMISSIONS.cricket,
      disable: false,
      priority: 10,
      onClick: true,
    },
    {
      name: 'Football',
      key: true,
      exact: true,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/exchange_sports/football',
      config: CONFIG_PERMISSIONS.football,
      disable: false,
      priority: 11,
      onClick: true,
    },
    {
      name: 'Tennis',
      key: true,
      exact: true,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/exchange_sports/tennis',
      config: CONFIG_PERMISSIONS.tennis,
      disable: false,
      priority: 12,
      onClick: true,
    },
    {
      name: 'Horse Racing',
      key: true,
      exact: true,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,  
      redirectionUrl: '/exchange_sports/horseracing',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 13,
      onClick: true,
    },
    {
      name: 'GreyHound',
      key: true,
      exact: true,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/exchange_sports/greyhound',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 14,
      onClick: true,
    },
    {
      name: 'Basketball',
      key: true,
      exact: true,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/exchange_sports/basketball',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 15,
      onClick: true,
    },
    {
      name: 'Baseball',
      key: true,
      exact: true,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/exchange_sports/baseball',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 16,
      onClick: true,
    },
    {
      name: 'TV Games',
      key: false,
      exact: false,
      className: 'nav-link',
      activeClassName: 'active-link',
      buttonClassName: 'nav-link-btn',
      icon: null,
      superScript: null,
      redirectionUrl: '/tv_games',
      config: CONFIG_PERMISSIONS.casino,
      disable: false,
      priority: 17,
      onClick: false,
    },
  ]);
  
  const { showSportsComponents, showCasinoComponents } = useDomainConfigHook();

  useEffect(() => {
    var subHeadersArray = subHeaders;

    if (!domainConfig.bonus) {
      subHeadersArray = subHeadersArray.filter(
        (item) => item.name !== 'Promotions'
      );
    } else {
      if (
        subHeadersArray.filter((item) => item.name === 'Promotions').length ===
        0
      ) {
        subHeadersArray.push({
          name: 'Promotions',
          key: false,
          exact: false,
          className: 'nav-link',
          activeClassName: 'active-link',
          buttonClassName: 'nav-link-btn',
          redirectionUrl: '/promotions',
          config: CONFIG_PERMISSIONS.sports,
          visibleForWhitelabel: true,
          disable: false,
          priority: 2,
          onClick: false,
        });
      }
    }
    contentConfig?.sub_headers.forEach((subHeader) => {
      var defaultSubHeader = subHeadersArray.filter(
        (item) => item.name.toLowerCase() === subHeader.name.toLowerCase()
      )[0];
      if (defaultSubHeader) {
        defaultSubHeader.disable = subHeader.disabled;
        defaultSubHeader.priority = subHeader.priority;
      }
    });
    subHeadersArray.sort((a, b) => a.priority - b.priority);

    setSubHeaders([...subHeadersArray.filter((elem) => !elem.disable)]);
  }, [contentConfig, domainConfig]);

  const isAllowed = (config) => {
    return config ? checkForDomainConfig(config, showSportsComponents, showCasinoComponents)
    : true; 
  };

  const isVisibleForWL = (subHeaderName: string) => {
    switch (subHeaderName.toLocaleLowerCase()) {
      case 'promotions': {
        return domainConfig.bonus;
      }
      case 'fun games': {
        return BRAND_NAME.toLocaleLowerCase() === 'betex247';
      }
      default: {
        return true;
      }
    }
  };

  const isChangeSite = (subHeaderName: string) =>
    subHeaderName.toLowerCase() !== 'change site' ||
    (!BRAND_DOMAIN.toLowerCase().includes('svkbook777.com') &&
    !BRAND_DOMAIN.toLowerCase().includes('kalki247.com'));

  const defaultSubHeaders = subHeaders.map((value, index) => {
    if (
      isAllowed(value.config) &&
      isVisibleForWL(value.name) &&
      isChangeSite(value.name)
    ) {
      return (
        <NavLink
          key={
            value?.key
              ? SPORTS_MAP.get(value.name).slug + index
              : value.name + index
          }
          exact={value?.exact ? value.exact : null}
          className={value.className}
          activeClassName={
            value?.activeClassName ? value.activeClassName : null
          }
          to={value.redirectionUrl}
          onClick={
            value.onClick
              ? () => setEventType(SPORTS_MAP.get(value.name))
              : null
          }
        >
          <Button className={value.buttonClassName}>
            {value?.icon ? value.icon : null}
            {value?.icon ? '\u00a0' : null}
            {value.name}
            {value?.superScript ? value.superScript : null}
          </Button>
        </NavLink>
      );
    }
    return null;
  });

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className="app-sub-header">
        <Tabs
          value={1}
          variant="scrollable"
          scrollButtons="off"
          className="actions-list"
        >
          {domainConfig.isDomainConfigLoading ? (
            <div className="loader-div">
              <IonSpinner className="loading-page-spinner" name="bubbles" />
            </div>
          ) : (
            <>{defaultSubHeaders}</>
          )}
        </Tabs>
      </div>
      <Backdrop className="backdrop-ctn" open={modalOpen}>
        <Modal
          open={modalOpen}
          closeHandler={modalCloseHandler}
          noTitle={true}
          size="xs"
        >
          <LoginForm modalCloseHandler={modalCloseHandler}></LoginForm>
        </Modal>
      </Backdrop>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    allowedConfig: state.common.allowedConfig,
    loggedIn: state.auth.loggedIn,
    contentConfig: state.common.contentConfig,
    domainConfig: state.common.domainConfig,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    logout: () => dispatch(logout()),
    fetchBettingCurrency: () => dispatch(fetchBettingCurrency()),
    setEventType: (et: SelectedObj) => dispatch(setEventType(et)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubHeader);
